import { render, staticRenderFns } from "./testTable.vue?vue&type=template&id=1f6905b7&scoped=true&"
import script from "./testTable.vue?vue&type=script&lang=js&"
export * from "./testTable.vue?vue&type=script&lang=js&"
import style0 from "./testTable.vue?vue&type=style&index=0&id=1f6905b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6905b7",
  null
  
)

export default component.exports